import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import 'element-plus/es/components/date-picker/style/css';

import { StColorPicker } from './color-picker.styled';

export default /*#__PURE__*/_defineComponent({
  __name: 'NkColorPicker',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ElColorPicker = _resolveComponent("ElColorPicker")!

  return (_openBlock(), _createBlock(_unref(StColorPicker), null, {
    default: _withCtx(() => [
      _createVNode(_component_ElColorPicker, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), null, 16)
    ]),
    _: 1
  }))
}
}

})